/*eslint-disable */
import React, { FC, useState, useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";

import styles from "./styles";
import Info from "Assets/images/info.svg";
import { motion } from "framer-motion";
import ShareMenuContainer from "Containers/ShareMenu";
import { MapContext } from "Context/MapContext";
import { sanitize } from "dompurify";

interface Props {
  media: any[];
  selectedIdx: number;
}

const Photoviewer: FC<Props> = (props: Props) => {
  const { media, selectedIdx } = props;
  const useStyles = createUseStyles(styles);

  const [description, setDescription] = useState(false);

  const theme = useTheme();

  const classes = useStyles({ theme, ...props, state: { description } });

  const { instId, locId } = useContext(MapContext);

  const shareUrl = `${process.env.REACT_APP_API_BASE_URL}tour/photos/${instId}/${locId}?id=${media[selectedIdx]?.id}`;

  const animations = {
    open: {
      x: "0%",
      transition: {
        ease: [0.28, 0.57, 0.2, 1],
        duration: 0.5,
      },
    },
    closed: {
      x: "100%",
      transition: {
        ease: "easeIn",
        duration: 0.25,
      },
    },
  };

  return (
    <div className={classes.viewer}>
      <div
        id={"carousel-title"}
        tabIndex={0}
        className={classes.imgText}
        data-testid="title"
        onBlur={() => {
          !media[selectedIdx].description &&
            !description &&
            document
              .getElementById(`carouselImages-${selectedIdx + 1}`)
              .focus();
        }}
      >
        {media[selectedIdx].title}
      </div>
      <img
        src={media[selectedIdx].mediumurl}
        className={classes.img}
        data-testid="photo"
      ></img>
      {description && (
        <motion.div
          initial={{ x: "100%" }}
          variants={animations}
          animate={description ? "open" : "closed"}
          className={classes.infoPanel}
        >
          <div
            id={"carousel-description"}
            tabIndex={0}
            className={classes.description}
            data-testid="description"
            dangerouslySetInnerHTML={{
              __html: sanitize(
                media[selectedIdx].description || media[selectedIdx].title,
                { ADD_ATTR: ["target"] }
              ),
            }}
            onBlur={() => {
              document
                .getElementById(`carouselImages-${selectedIdx + 1}`)
                .focus();
            }}
          ></div>
        </motion.div>
      )}

      {media[selectedIdx].description && (
        <button
          aria-label={"Open Description"}
          tabIndex={0}
          className={classes.info}
          onClick={() => setDescription(!description)}
          data-testid="info"
          style={{ background: "transparent", border: "none" }}
          onBlur={() => {
            if (!description && !media[selectedIdx].description)
              document
                .getElementById(`carouselImages-${selectedIdx + 1}`)
                .focus();
            else if (description)
              document.getElementById(`carousel-description`).focus();
          }}
        >
          <Info />
        </button>
      )}
      <div>
        <span
          style={{
            cursor: "pointer",
            position: "absolute",
            bottom: "0%",
            right: "2%",
          }}
        >
          <ShareMenuContainer url={shareUrl} svgColor="#FFFFFF" />
        </span>
      </div>
    </div>
  );
};

export default Photoviewer;
